import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ChainId } from '@nominex/nomiswap-sdk'
import { AppState } from 'state'
import { useIsAuthenticated } from 'state/profile/hooks'
import { FetchStatus } from 'state/types'
import { Link } from 'react-router-dom'
import { ProSidebar, SidebarContent, SidebarFooter, SidebarHeader } from 'react-pro-sidebar'
import {
  // BookIcon,
  ChevronLeftIcon,
  LogoIcon,
  LogoWithTextIcon,
  useMatchBreakpoints,
} from '@nominex/dex-uikit'
import { SlButton } from '@shoelace-style/shoelace/dist/react'
import DropdownTrigger from 'components/Menu/ExtraRewardsDropdown/DropdownTrigger'
import { useWagmi } from 'libs/wagmi'
import { COLLAPSED_WIDTH, WIDTH } from './config/config'
import MainMenu from './views/MainMenu'
import { AsideStyled, SidebarToggleStyled } from './styles/styles'

import 'react-pro-sidebar/dist/css/styles.css'
import './styles/styles.css'
import ExtraRewardsPanel from './panels/ExtraRewardsPanel'

declare global {
  interface Window {
    kayako: any
  }
}

// const { kayako } = window

const Aside = ({ collapsed, toggled, switchCollapsedState, closeSidebar, switchToggledState }) => {
  const { isMobile } = useMatchBreakpoints()
  const { account, chain } = useWagmi()
  const isAuthenticated = useIsAuthenticated()
  const [openPanel, setOpenPanel] = useState(false)
  const { fetchStatus: bonusesFetchStatus, total } = useSelector((state: AppState) => state.affiliate.user.bonuses)

  const [collapseToggleVisible, setCollapseToggleVisibility] = useState(!isMobile)

  const showCollapseToggle = (value: boolean) => {
    setCollapseToggleVisibility(value)
  }

  // const toggleKayakoMessenger = () => {
  //   kayako.ready(() => {
  //     if (kayako.visibility() === 'minimized') {
  //       kayako.maximize()
  //     } else {
  //       kayako.minimize()
  //     }
  //   })
  // }

  const onToggle = () => {
    switchToggledState()
  }

  return (
    <AsideStyled
      id="main-navigation"
      collapseToggleVisible={collapseToggleVisible}
      isMobile={isMobile}
      onMouseEnter={() => showCollapseToggle(true)}
      onMouseLeave={() => showCollapseToggle(false)}
    >
      <ProSidebar
        collapsed={collapsed && !isMobile}
        toggled={toggled}
        onToggle={onToggle}
        breakPoint="sm"
        width={`${WIDTH}px`}
        collapsedWidth={`${COLLAPSED_WIDTH}px`}
      >
        <SidebarHeader style={{ position: 'relative' }}>
          <div className="px-24 py-32">
            <Link onClick={closeSidebar} to="/">
              {collapsed && !isMobile ? (
                <LogoIcon width="30px" height="30px" />
              ) : (
                <LogoWithTextIcon width="160px" height="32px" />
              )}
            </Link>
          </div>
          {(collapseToggleVisible || collapsed) && !isMobile && (
            <SidebarToggleStyled
              onClick={switchCollapsedState}
              collapsed={collapsed}
              visible={collapseToggleVisible || collapsed}
            >
              <ChevronLeftIcon />
            </SidebarToggleStyled>
          )}
        </SidebarHeader>
        <SidebarContent>
          <div className="flex flex-col items-stretch justify-between h-[100%]">
            <MainMenu closeSidebar={closeSidebar} />
          </div>
        </SidebarContent>
        <SidebarFooter>
          {isAuthenticated && account && isMobile && chain?.id === ChainId.BSC && (
            <div className="flex">
              <SlButton
                variant="text"
                className="px-32"
                onClick={() => {
                  setOpenPanel(!openPanel)
                  closeSidebar()
                }}
              >
                <DropdownTrigger nmxReward={total} isLoaded={bonusesFetchStatus !== FetchStatus.FETCHED} />
              </SlButton>
              <ExtraRewardsPanel openPanel={openPanel} onClosed={() => setOpenPanel(false)} />
            </div>
          )}
        </SidebarFooter>
      </ProSidebar>
    </AsideStyled>
  )
}

export default Aside
